import { CHAT_STATE } from '../constants';

export const getIsChatMessagingInProgress = (storeState) =>
  storeState.chat.state === CHAT_STATE.IN_PROGRESS || storeState.chat.state === CHAT_STATE.FILE_UPLOAD_ENABLED;

export const getIsChatIdle = (storeState) => storeState.chat.state === CHAT_STATE.IDLE;
export const getIsChatRendered = (storeState) => storeState.chat.state !== CHAT_STATE.IDLE;
export const getChatSettings = (storeState) => storeState.chat.setting;
export const getChatRate = (storeState) => storeState.chat.rate;
export const getChatHideRatingScreen = (storeState) => storeState.chat.hideRatingScreen;
export const getChatState = (storeState) => storeState.chat.state;
export const getChatPosition = (storeState) => storeState.chat.position;

export const didOperatorLostConnection = (storeState) => storeState.chat.state === CHAT_STATE.OPERATOR_LOST_CONNECTION;
export const isChatEndedByUser = (storeState) => storeState.chat.state === CHAT_STATE.ENDED_BY_USER;
export const isFileUploadEnabled = (storeState) => storeState.chat.state === CHAT_STATE.FILE_UPLOAD_ENABLED;

export const getRequestId = (storeState) => storeState.chat && storeState.chat.requestId;

export const getFeedback = (storeState) => storeState.chat && storeState.chat.feedback;
